(() => {
  function syncBranch(layout, id) {
    const sidebar = layout.querySelector('.ec-mega-menu__sidebar');
    const main = layout.querySelector('.ec-mega-menu__main');
    if (!sidebar || !main) return;

    const items = [...sidebar.querySelectorAll('.ec-mega-menu__level2-item')];
    const panels = [...main.querySelectorAll('.ec-mega-menu__level3')];
    const sid = String(id);
    const hasPanel = panels.some((p) => p.dataset.ecMegaId === sid);

    items.forEach((li) => {
      li.classList.toggle('ec-mega-menu__level2-item--hover', li.dataset.ecMegaId === sid);
    });
    panels.forEach((p) => {
      p.classList.toggle('ec-mega-menu__level3--visible', hasPanel && p.dataset.ecMegaId === sid);
    });
  }

  function resetToDefault(layout) {
    const sidebar = layout.querySelector('.ec-mega-menu__sidebar');
    const main = layout.querySelector('.ec-mega-menu__main');
    if (!sidebar || !main) return;

    const items = [...sidebar.querySelectorAll('.ec-mega-menu__level2-item')];
    const panels = [...main.querySelectorAll('.ec-mega-menu__level3')];

    items.forEach((li) => li.classList.remove('ec-mega-menu__level2-item--hover'));
    panels.forEach((p) => p.classList.remove('ec-mega-menu__level3--visible'));

    const def = items.find((li) => li.classList.contains('ec-mega-menu__level2-item--default'));
    if (!def) return;
    const pid = def.dataset.ecMegaId;
    const panel = panels.find((p) => p.dataset.ecMegaId === pid);
    if (panel) panel.classList.add('ec-mega-menu__level3--visible');
  }

  function initLayout(layout) {
    if (layout.dataset.ecMegaHoverInit === 'true') return;
    layout.dataset.ecMegaHoverInit = 'true';

    const sidebar = layout.querySelector('.ec-mega-menu__sidebar');
    const main = layout.querySelector('.ec-mega-menu__main');
    if (!sidebar || !main) return;

    const content = layout.closest('.mega-menu__content');
    const leaveZone = content || layout;
    let leaveTimer = null;

    const cancelScheduledReset = () => {
      if (leaveTimer != null) {
        window.clearTimeout(leaveTimer);
        leaveTimer = null;
      }
    };

    const scheduleReset = () => {
      cancelScheduledReset();
      leaveTimer = window.setTimeout(() => {
        leaveTimer = null;
        resetToDefault(layout);
      }, 120);
    };

    leaveZone.addEventListener('mouseenter', cancelScheduledReset);

    leaveZone.addEventListener('mouseleave', (event) => {
      if (leaveZone.contains(event.relatedTarget)) return;
      scheduleReset();
    });

    sidebar.querySelectorAll('.ec-mega-menu__level2-link').forEach((link) => {
      link.addEventListener('mouseenter', () => {
        cancelScheduledReset();
        const li = link.closest('.ec-mega-menu__level2-item');
        if (!li || !sidebar.contains(li)) return;
        syncBranch(layout, li.dataset.ecMegaId);
      });
    });

    layout.addEventListener('focusin', (event) => {
      cancelScheduledReset();
      const t = event.target;
      if (t.closest && t.closest('.ec-mega-menu__promos')) return;
      const li = t.closest && t.closest('.ec-mega-menu__level2-item');
      const panelEl = t.closest && t.closest('.ec-mega-menu__level3');
      if (li && sidebar.contains(li)) {
        const link = li.querySelector('.ec-mega-menu__level2-link');
        if (link && (t === link || link.contains(t))) {
          syncBranch(layout, li.dataset.ecMegaId);
          return;
        }
        return;
      }
      if (panelEl && main.contains(panelEl)) {
        syncBranch(layout, panelEl.dataset.ecMegaId);
      }
    });

    layout.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!layout.contains(document.activeElement)) resetToDefault(layout);
      }, 0);
    });
  }

  function initAll() {
    document
      .querySelectorAll('.ec-mega-menu__layout:not(.ec-mega-menu__layout--single)')
      .forEach(initLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
